import gsap from 'gsap';

class BannerSVG {
    constructor() {
        this.paths = {
            path1: document.querySelector('#cta--triangle--path1'),
            path2: document.querySelector('#cta--triangle--path2'),
            path3: document.querySelector('#cta--triangle--path3')
        };

        this.initialPaths = {
            path1: 'M 126.4184 239.7557 L 633.0587 359.5359 L 315.8777 359.3724 L 126.4184 239.7557 Z',
            path2: 'M 128.0945 239.7557 L -0.0249 1.5332 L -1.9046 359.3724 L 128.0945 239.7557 Z',
            path3: 'M 128.0954 239.7537 L 317.5538 359.3705 H -1.9046 L 128.0954 239.7537 Z'
        };

        this.targetPaths = {
            path1: 'M 158.9983 228.0006 L 632.0001 379.9989 L 382.9965 378.999 L 158.9983 228.0006 Z',
            path2: 'M 158.9984 228.0006 L -0.0249 1.5332 L -0.0001 378.999 L 158.9984 228.0006 Z',
            path3: 'M 158.9984 228.0006 L 382.9966 378.999 H -0.0001 L 158.9984 228.0006 Z'
        };

        this.init();
    }

    init() {
        if (!this.paths.path1 || !this.paths.path2 || !this.paths.path3) {
            return;
        }

        const timeline = gsap.timeline({
            repeat: -1,
            yoyo: true,
            defaults: {
                duration: 5,
                ease: "power2.inOut"
            }
        });

        timeline
            .to(this.paths.path1, {
                attr: { d: this.targetPaths.path1 }
            })
            .to(this.paths.path2, {
                attr: { d: this.targetPaths.path2 }
            }, "<")
            .to(this.paths.path3, {
                attr: { d: this.targetPaths.path3 }
            }, "<");
    }
} export default BannerSVG;
